import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const MenuService = {

    async Get() {  return await methods.Get("Menu/Get" ); },
    async Post(data) { return await methods.Post("Menu/Post", data) },
    async Put(qs, data) { return await methods.Put("Menu/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("Menu/Delete" + useParamsJson(qs)) }
};

export default MenuService;